export default __webpack_public_path__ + "static/media/chrome.1bffca36.svg";